<template>
  <div
    class="home_goods_shelf_zone mt10 ml11 mr11"
    v-if="zone.groupList.length"
  >
    <div class="title_row" v-if="zone.titleurl">
      <img
        class="title_img radius-8px"
        :src="zone.titleurl"
        alt=""
        @error="onImgError"
      />
    </div>
    <div class="pt10 pb10 pl10 pr8 radius-8px" :style="section_bg">
      <div class="flex ai-c" :class="index != 0 ? 'mt10' : ''" v-for="(g, index) in zone.groupList" :key="'sg-' + index">
        <img
          class="group_img radius-8px"
          :src="g.groupimg"
          alt=""
          @error="onImgError"
        />
        <div class="flex-1 ml6 scroll_row hide_scrollbar">
          <div class="scroll_inner">
            <div
              v-for="(goods, goodsIndex) in g.goodsList"
              :key="'sg-' + goodsIndex"
              class="shelf_card radius-8px"
              @click="goodsHandle(goods, goodsIndex, flow_area_prefix + '-' + (index + 1))"
            >
              <div class="shelf_img_wrap">
                <img
                  class="shelf_img radius-8px"
                  :src="goods.img_path || '/static/images/errorimg.jpg'"
                  alt=""
                  @error="onImgError"
                />
              </div>
              <p class="shelf_name over-ell-1 ml4 mr4">{{ goods.name }}</p>
              <div class="original_price_row flex-js-ac ml4 mr4">
                <span class="price">原价：¥{{ splitPriceFixed2(goods.original_price).int }}.{{ splitPriceFixed2(goods.original_price).dec }}</span>
              </div>
              <div class="shelf_price_row flex-js-ac ml4 mr4">
                <span class="price">
                  到手价:¥<span class="f11">{{ splitPriceFixed2(goods.price).int }}</span>.{{ splitPriceFixed2(goods.price).dec }}
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * goodsShelfZone 单项（ajax.js）：titleurl, bgimg, groupList[{ groupimg, goodsList[{ name, img_path, original_price, price, itemid }] }]
 */
export default {
  name: 'homeGoodsShelfZone',
  props: {
    zone: {
      type: Object,
      default: () => ({})
    },
    flow_area_prefix: {
      type: String,
      default: 'goodsShelfZone'
    }
  },
  computed: {
    section_bg() {
      const bg = this.zone.bgimg
      if (!bg) return {}
      return {
        background: `url(${bg}) center top / 100% 100% no-repeat`
      }
    }
  },
  methods: {
    splitPriceFixed2(val) {
      var n = parseFloat(val)
      if (isNaN(n)) n = 0
      var parts = n.toFixed(2).split('.')
      return { int: parts[0], dec: parts[1] || '00' }
    },
    goodsHandle(g, index, tag) {
      let info = {
        ad_type: '3',
        ad_target: g.itemid,
        ad_title: g.name,
        ...g
      }
      this.$emit('banner-click', info, index, tag + '-' + (index + 1))
    },
    onImgError(e) {
      const img = e.target
      img.src = '/static/images/errorimg.jpg'
      img.onerror = null
    }
  }
}
</script>

<style scoped lang="scss">

.title_row {
  padding: 0 0 0.08rem;
}

.title_more_row {
  padding-top: 0.06rem;
}

.title_more_row .zone_more {
  font-size: 0.12rem;
  color: #999;
  display: flex;
  align-items: center;
  gap: 0.02rem;
}

.title_img {
  display: block;
  width: 100%;
  height: auto;
}

.zone_header {
  padding: 0 0.1rem 0.1rem;
}

.zone_title {
  margin: 0;
  font-size: 0.22rem;
  font-weight: 700;
  color: #222;
}

.zone_more {
  font-size: 0.12rem;
  color: #999;
  display: flex;
  align-items: center;
  gap: 0.02rem;
}

.scroll_row {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
}
.group_img {
  display: block;
  width: 0.31rem;
  height: 1.45rem;
}

.scroll_inner {
  display: inline-flex;
  flex-direction: row;
  gap: 0.06rem;
  min-width: min-content;
}

.shelf_card {
  flex: 0 0 0.95rem;
  width: 0.95rem;
  height: 1.41rem;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 0.02rem 0.08rem rgba(0, 0, 0, 0.06);
}

.shelf_img_wrap {
  width: 100%;
  height: 0.95rem;
  background: #f7f7f7;
}

.shelf_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.shelf_name {
  margin: 0.03rem 0 0;
  font-size: 0.11rem;
  color: #292929;
  line-height: 1.2;
}

.original_price_row {
  margin: 0.03rem 0 0.02rem;
}

.original_price_row .price {
  font-size: 0.09rem;
  color: #292929;
}
.original_price_row,.shelf_price_row  {
  line-height: 1;
}
.shelf_price_row .price {
  font-size: 0.09rem;
  font-weight: bold;
  color: #fc0324;
  display: inline-flex;
  align-items: baseline;
}

.shelf_price_row .price_int {
  font-size: 0.09rem;
}

.shelf_price_row .price_dec {
  font-size: 0.11rem;
  font-weight: bold;
}

.buy_btn {
  width: 0.22rem;
  height: 0.22rem;
  border-radius: 50%;
  background: #fc0324;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.12rem;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/homeGoodsShelfZone.vue